import {
  ClientUserNameField,
  ClientUserPhoneField,
} from '@src/clientUser/manage/ClientUserFormInputs';
import * as yup from 'yup';

export const EditClientUserFormInputs = yup
  .object()
  .shape({
    [ClientUserNameField.fieldName]: ClientUserNameField.validator,
    [ClientUserPhoneField.fieldName]: ClientUserPhoneField.validator,
  })
  .required();
